import { useEffect, useState } from "react";
import { FileCheck2, Download } from "lucide-react";
import { toast } from "sonner";
import { http, formatApiError } from "../lib/api";

export const DOC_LANGS = [["fr", "Français"], ["en", "English"], ["de", "Deutsch"], ["es", "Español"], ["it", "Italiano"], ["nl", "Nederlands"], ["pt", "Português"], ["ar", "العربية (Arabe)"]];

export const DocLangSelect = ({ value, onChange, testid }) => (
  <select data-testid={testid} className="input" value={value || "fr"} onChange={(e) => onChange(e.target.value)}>
    {DOC_LANGS.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
  </select>
);

const fdt = (iso) => new Date(iso).toLocaleString("fr-FR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
const ST = { active: ["Active / valide", "text-emerald-700"], closed: ["Fermée / invalide", "text-rose-700"], not_found: ["Introuvable", "text-amber-700"] };
const SRC = { fr: "SIRENE", uk: "Companies House", ch: "Zefix", vies: "VIES" };

export const RegistryProofs = ({ clientId }) => {
  const [rows, setRows] = useState([]);
  useEffect(() => { if (clientId) http.get(`/clients/${clientId}/registry-proofs`).then((r) => setRows(r.data)).catch(() => {}); }, [clientId]);
  if (!clientId) return null;
  const dl = async (r) => {
    try {
      const res = await http.get(`/clients/${clientId}/registry-proofs/${r.id}/pdf`, { responseType: "blob" });
      Object.assign(document.createElement("a"), { href: URL.createObjectURL(res.data), download: `Preuve_registre_${r.at.slice(0, 10)}.pdf` }).click();
    } catch (e) { toast.error(formatApiError(e)); }
  };
  return (
    <div className="mt-3 border border-slate-200 rounded-md p-3" data-testid="registry-proofs">
      <div className="flex items-center gap-2 text-[10px] font-bold uppercase tracking-widest text-slate-500 mb-1"><FileCheck2 className="h-3.5 w-3.5" />Preuves de vérification ({rows.length})</div>
      {!rows.length && <div className="text-xs text-slate-400">Aucune vérification enregistrée pour ce client.</div>}
      <div className="max-h-36 overflow-auto divide-y divide-slate-100 text-xs">
        {rows.map((r) => (
          <div key={r.id} className="py-1.5 flex items-center gap-2" data-testid={`registry-proof-${r.id}`}>
            <span className="text-slate-500 whitespace-nowrap">{fdt(r.at)}</span>
            <span className="font-semibold">{SRC[r.source] || r.source}</span>
            <span className="font-mono text-slate-500 truncate">{r.identifier}</span>
            <span className={`font-semibold ${(ST[r.status] || ST.not_found)[1]}`}>{(ST[r.status] || ST.not_found)[0]}{r.label ? ` (${r.label})` : ""}</span>
            <button type="button" data-testid={`registry-proof-dl-${r.id}`} onClick={() => dl(r)} className="ml-auto inline-flex items-center gap-1 text-sky-700 font-semibold hover:underline"><Download className="h-3.5 w-3.5" />PDF</button>
          </div>
        ))}
      </div>
    </div>
  );
};
